<template>
    <v-container fluid grid-list-md>
        <v-form ref="form2" v-model="valid" style="padding-bottom: 8px">
            <v-row content-align="center" no-gutters>
                <v-col class="d-flex" cols="12" sm="12">
                    <v-text-field-filled
                        v-model="password"
                        append-inner-icon="$oss-eye"
                        :type="show ? 'text' : 'password'"
                        label="Mot de Passe"
                        required
                        :rules="[rules.notEmpty]"
                        outlined
                        density="compact"
                        @click:append-inner="show = !show"
                    />
                </v-col>
            </v-row>
        </v-form>
        <v-alert type="error" :model-value="errorCredentials">
            <div>Mot de passe incorrect</div>
            <span class="font-italic" style="font-size: 0.65em">
                {{ specialErrorMessage }}
            </span>
        </v-alert>
    </v-container>
</template>

<script lang="ts">
import { AccountingConfigAPIBase } from "../../admin/AccountingConfigAPIBase";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class SettingUpdateMailPassword extends AccountingConfigAPIBase {
    loading = false;
    errorCredentials = false;
    validPassword = false;
    password = "";
    show = false;

    // get dialog() {
    //     return this.value
    // }

    // set dialog(event) {
    //     this.$emit('input', event)
    // }

    // async testAndModification(type, index) {
    //     this.loading = true
    //     const info = await this.$apollo.mutate({
    //         mutation: UPDATE_PROFILE_COMPANY_UPDATE_MAIL,
    //         variables: {
    //             profileId: this.profileId,
    //             type: type,
    //             accountingMailConfig: this.config.accountingMailConfig,
    //             documentFromMailConfig: this.config.documentFromMailConfig,
    //             sendingMailSMTPConfig: this.config.sendingMailSMTPConfig,
    //             index: index,
    //             password: this.password
    //         },
    //     })
    //     if(this.errorConnexion(info.data.updateProfileCompanyUpdateMail.infoUpdate) ){
    //         this.errorCredentials = true
    //     } else {
    //         this.errorCredentials = false
    //         this.reinitializeCredentials()
    //         this.$emit("onUpdate")
    //         // this.dialog = false
    //     }
    //     this.loading = false
    // }

    errorConnexion(infoUpdate) {
        if (infoUpdate === this.profileId) {
            return false;
        }
        return true;
    }

    reinitializeCredentials() {
        // this.type = ''
        this.validPassword = false;
        this.loading = false;
        this.errorCredentials = false;

        // this.index = -1

        this.password = "";
        this.show = false;
    }
}

export default toNative(SettingUpdateMailPassword);
</script>
